import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  product: {},
  errors: {},
  filters: {
    loaded: false,
    categories: [],
    types: []
  },
  requesting: null,
  submitting: null,
  isSaved: false,
};

const Slice = createSlice({
  name: '@admin/Inventory|Products|Form',
  initialState,
  reducers: {
    
    
  /**
   * RESET
   */
  initialState: (state) => {
    state.requesting = null;
    state.submitting = null;
    state.errors = {};
    state.product = {};
    state.isSaved = false;
  },

  /**
   * GET PRODUCT
   */
  getProduct: (state) => {
    state.requesting = true;
    state.product = {};
  },
  getProductSuccess: (state, action) => {
    const { payload } = action;
    state.product = payload;
    state.requesting = false;
  },
  getProductFailed: (state, action) => {
    state.errors = action.payload;
    state.requesting = false;
  },

  /**
   * GET FORM FILTERS
   */
  getFormFilters: (state) => {
    state.filters.loaded = false;
  },
  getFormFiltersSuccess: (state, action) => {
    const { payload } = action;
    state.filters = { ...payload, loaded: true };
  },
  getFormFiltersFailed: (state, action) => {
    state.errors = action.payload;
  },
  /**
   * SAVE FORM
   */
  saveForm: (state) => {
    state.submitting = true;
    state.isSaved = false;
    state.errors = {};
  },
  saveFormSuccess: (state, action) => {
    const { payload } = action;
    state.product = payload;
    state.submitting = false;
    state.isSaved = true;
  },
  saveFormFailed: (state, action) => {
    state.errors = action.payload;
    state.submitting = false;
    state.isSaved = false;
  },
    
  },
});

export const Actions = Slice.actions;

const Reducers = {
  AdminInventoryProductFormReducers: Slice.reducer,
}
export default Reducers;